import * as React from 'react';

import { ContentCard } from '@rematter/ui-web';

import { ItemGroupFormState } from '../../../_state/itemGroupForm.state';
import { ItemGroupRecord } from '../../../types/inventoryItem';

import { ItemGroupDetailsForm } from './ItemGroupDetailsForm';
import { ItemGroupFormFooterActions } from './ItemGroupFormFooterActions';

type Props = {
  itemGroup?: ItemGroupRecord | null;
  onDiscard?: () => void;
  onSaveUpdates?: (data?: ItemGroupFormState) => void;
  isSaving?: boolean;
};

export const ItemGroupTabDetails: React.FC<Props> = ({
  itemGroup,
  onDiscard,
  onSaveUpdates,
  isSaving = false,
}) => (
  <div className="@ItemGroupTabDetails flex max-h-full flex-col gap-5 p-5">
    <ContentCard className="p-0 pt-5">
      <ItemGroupDetailsForm itemGroup={itemGroup} disabled={false} />
      <ItemGroupFormFooterActions
        onSaveUpdates={onSaveUpdates}
        onDiscard={onDiscard}
        isSaving={isSaving}
      />
    </ContentCard>
  </div>
);
